import { WeekOfTheYearKey } from 'classes/WeekOfTheYearKey'

export const TRAINING_TIMELINE_ITEM_WIDTH_SCALE = 0.7
export const TRAINING_TIMELINE_ITEM_WIDTH_SCALE_2XL = 0.9
export const TAILWIND_2XL_QUERY = '(min-width: 1536px)'

export const GenerateEmptyProgramWeeks = (renderRangeStart, renderRangeEnd, daySpacing, dateToTrackLeftX, dateToWeekIndex) => {

    if (daySpacing <= 0 || !renderRangeStart || !renderRangeEnd) {
        return []
    }

    const bars = []
    const weekCursor = renderRangeStart.clone().startOf('isoWeek')

    while (weekCursor.isSameOrBefore(renderRangeEnd, 'day')) {

        const weekStart = weekCursor.clone()
        const left = dateToTrackLeftX(weekStart)
        const weekOfTheYearKey = new WeekOfTheYearKey(weekStart).toString()

        bars.push({
            key: weekOfTheYearKey,
            left,
            width: dateToTrackLeftX(weekStart.clone().add(1, 'week')) - left,
            weekIndex: dateToWeekIndex(weekStart),
            weekOfTheYearKey,
        })

        weekCursor.add(1, 'week')
    }

    return bars

}